import React, { useState } from 'react'
import TextInput from '../../../../components/atoms/TextInput/TextInput'
import Button from '../../../../components/atoms/Button/Button'
import useNavigationApp from '../../../../navigation/hook/useNavigationApp';

export interface LoadingViewProps {}

export function LoadingView() {
  return (
    <div style={{
      maxWidth: '400px',
      margin: '0 auto',
      padding: '40px 20px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '24px',
      textAlign: 'center'
    }}>
      <div style={{
        width: '80px',
        height: '80px',
        borderRadius: '50%',
        backgroundColor: '#e3f2fd',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '16px'
      }}>
        <div style={{
          width: '40px',
          height: '40px',
          border: '4px solid #bbdefb',
          borderTop: '4px solid #2196f3',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }} />
      </div>

      <div>
        <h1 style={{
          fontSize: '24px',
          fontWeight: '600',
          color: '#1976d2',
          margin: '0 0 12px 0'
        }}>
          Chargement...
        </h1>
        
        <p style={{
          fontSize: '16px',
          color: '#666',
          margin: '0',
          lineHeight: '1.5'
        }}>
          Vérification de votre demande de réinitialisation en cours.
        </p>
      </div>

      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  )
}

export interface ErrorViewProps {
  message?: string;
}

export function ErrorView({ message = "Erreur lors du chargement de la requête de réinitialisation de mot de passe" }: ErrorViewProps) {
  const { goToHome } = useNavigationApp()
    return (
    <div style={{
      maxWidth: '400px',
      margin: '0 auto',
      padding: '40px 20px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '24px',
      textAlign: 'center'
    }}>
      <div style={{
        width: '80px',
        height: '80px',
        borderRadius: '50%',
        backgroundColor: '#f44336',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '16px'
      }}>
        <svg 
          width="40" 
          height="40" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="white" 
          strokeWidth="2"
        >
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="15" y1="9" x2="9" y2="15"></line>
          <line x1="9" y1="9" x2="15" y2="15"></line>
        </svg>
      </div>

      <div>
        <h1 style={{
          fontSize: '24px',
          fontWeight: '600',
          color: '#d32f2f',
          margin: '0 0 12px 0'
        }}>
          Erreur
        </h1>
        
        <p style={{
          fontSize: '16px',
          color: '#666',
          margin: '0',
          lineHeight: '1.5'
        }}>
          {message}
        </p>
      </div>

      <div style={{
        width: '100%',
        padding: '16px',
        backgroundColor: '#ffebee',
        borderRadius: '8px',
        border: '1px solid #ffcdd2'
      }}>
        <p style={{
          fontSize: '14px',
          color: '#d32f2f',
          margin: '0',
          fontWeight: '500'
        }}>
          ⚠ Veuillez réessayer ou contacter le support
        </p>
      </div>

      <Button
        label="Retour à l'accueil"
        onClick={() => goToHome()}
        variant="primary"
        height="48px"
      />
    </div>
  )
}

export interface ExpiredViewProps {}

export function ExpiredView() {
  const { goToResetPasswordRequest } = useNavigationApp()
  return (
    <div style={{
      maxWidth: '400px',
      margin: '0 auto',
      padding: '40px 20px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '24px',
      textAlign: 'center'
    }}>
      <div style={{
        width: '80px',
        height: '80px',
        borderRadius: '50%',
        backgroundColor: '#ff9800',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '16px'
      }}>
        <svg 
          width="40" 
          height="40" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="white" 
          strokeWidth="2"
        >
          <circle cx="12" cy="12" r="10"></circle>
          <polyline points="12,6 12,12 16,14"></polyline>
        </svg>
      </div>

      <div>
        <h1 style={{
          fontSize: '24px',
          fontWeight: '600',
          color: '#f57c00',
          margin: '0 0 12px 0'
        }}>
          Lien expiré
        </h1>
        
        <p style={{
          fontSize: '16px',
          color: '#666',
          margin: '0',
          lineHeight: '1.5'
        }}>
          La demande de réinitialisation de mot de passe a expiré ou a déjà été utilisée.
        </p>
      </div>

      <div style={{
        width: '100%',
        padding: '16px',
        backgroundColor: '#fff3e0',
        borderRadius: '8px',
        border: '1px solid #ffcc02'
      }}>
        <p style={{
          fontSize: '14px',
          color: '#f57c00',
          margin: '0',
          fontWeight: '500'
        }}>
          ⏰ Demandez une nouvelle réinitialisation
        </p>
      </div>

      <Button
        label="Nouvelle demande"
        onClick={() => goToResetPasswordRequest()}
        variant="primary"
        height="48px"
      />
    </div>
  )
}

export interface NotFoundViewProps {}

export function NotFoundView() {
  const { goToResetPasswordRequest } = useNavigationApp()
  return (
    <div style={{
      maxWidth: '400px',
      margin: '0 auto',
      padding: '40px 20px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '24px',
      textAlign: 'center'
    }}>
      <div style={{
        width: '80px',
        height: '80px',
        borderRadius: '50%',
        backgroundColor: '#9e9e9e',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '16px'
      }}>
        <svg 
          width="40" 
          height="40" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="white" 
          strokeWidth="2"
        >
          <circle cx="11" cy="11" r="8"></circle>
          <path d="21 21l-4.35-4.35"></path>
          <line x1="11" y1="8" x2="11" y2="14"></line>
          <line x1="8" y1="11" x2="14" y2="11"></line>
        </svg>
      </div>

      <div>
        <h1 style={{
          fontSize: '24px',
          fontWeight: '600',
          color: '#616161',
          margin: '0 0 12px 0'
        }}>
          Lien non trouvé
        </h1>
        
        <p style={{
          fontSize: '16px',
          color: '#666',
          margin: '0',
          lineHeight: '1.5'
        }}>
          L'identifiant de réinitialisation de mot de passe est manquant ou invalide.
        </p>
      </div>

      <div style={{
        width: '100%',
        padding: '16px',
        backgroundColor: '#f5f5f5',
        borderRadius: '8px',
        border: '1px solid #e0e0e0'
      }}>
        <p style={{
          fontSize: '14px',
          color: '#616161',
          margin: '0',
          fontWeight: '500'
        }}>
          🔗 Vérifiez le lien dans votre email
        </p>
      </div>

      <Button
        label="Nouvelle demande"
        onClick={() => goToResetPasswordRequest()}
        variant="primary"
        height="48px"
      />
    </div>
  )
}

export interface SuccessViewProps {}

export function SuccessView() {
  const { goToLogin } = useNavigationApp()
  return (
    <div style={{
      maxWidth: '400px',
      margin: '0 auto',
      padding: '40px 20px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '24px',
      textAlign: 'center'
    }}>
      <div style={{
        width: '80px',
        height: '80px',
        borderRadius: '50%',
        backgroundColor: '#4caf50',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '16px'
      }}>
        <svg 
          width="40" 
          height="40" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="white" 
          strokeWidth="2"
        >
          <polyline points="20,6 9,17 4,12"></polyline>
        </svg>
      </div>

      <div>
        <h1 style={{
          fontSize: '24px',
          fontWeight: '600',
          color: '#2e7d32',
          margin: '0 0 12px 0'
        }}>
          Mot de passe réinitialisé !
        </h1>
        
        <p style={{
          fontSize: '16px',
          color: '#666',
          margin: '0',
          lineHeight: '1.5'
        }}>
          Votre mot de passe a été réinitialisé avec succès. 
          Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.
        </p>
      </div>

      <div style={{
        width: '100%',
        padding: '16px',
        backgroundColor: '#f1f8e9',
        borderRadius: '8px',
        border: '1px solid #c8e6c9'
      }}>
        <p style={{
          fontSize: '14px',
          color: '#388e3c',
          margin: '0',
          fontWeight: '500'
        }}>
          ✓ Votre compte est maintenant sécurisé
        </p>
      </div>

      <Button
        label="Retour à la connexion"
        onClick={() => goToLogin()}
        variant="primary"
        height="48px"
      />
    </div>
  )
}

export interface ResetPasswordFormViewProps {
  handleSubmit: (newPassword: string) => void;
  isLoading?: boolean;
  error?: string | null;
  token?: string;
}

export default function ResetPasswordFormView({ 
  handleSubmit, 
  isLoading = false, 
  error 
}: ResetPasswordFormViewProps) {
  const [newPassword, setNewPassword] = useState<string>('')
  const [confirmPassword, setConfirmPassword] = useState<string>('')
  const [errors, setErrors] = useState<{
    newPassword?: string;
    confirmPassword?: string;
  }>({})

  const validateForm = () => {
    const newErrors: typeof errors = {}
    
    if (!newPassword) {
      newErrors.newPassword = 'Le nouveau mot de passe est requis'
    } else if (newPassword.length < 8) {
      newErrors.newPassword = 'Le mot de passe doit contenir au moins 8 caractères'
    }
    
    if (!confirmPassword) {
      newErrors.confirmPassword = 'La confirmation du mot de passe est requise'
    } else if (newPassword !== confirmPassword) {
      newErrors.confirmPassword = 'Les mots de passe ne correspondent pas'
    }
    
    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleFormSubmit = () => {
    if (validateForm()) {
      handleSubmit(newPassword)
    }
  }

  return (
    <div style={{ 
      maxWidth: '400px', 
      margin: '0 auto', 
      padding: '20px',
      display: 'flex',
      flexDirection: 'column',
      gap: '20px'
    }}>
      <h1>Nouveau mot de passe</h1>

      {error && (
        <div style={{ 
          color: '#d32f2f', 
          backgroundColor: '#ffebee', 
          padding: '12px', 
          borderRadius: '4px',
          fontSize: '14px'
        }}>
          {error}
        </div>
      )}


        <TextInput
          label="Nouveau mot de passe"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          placeholder="Saisissez votre nouveau mot de passe"
          error={!!errors.newPassword}
          style={{ marginBottom: '8px' }}
          type='password'
  
        />
        {errors.newPassword && (
          <div style={{ color: '#d32f2f', fontSize: '12px', marginTop: '4px' }}>
            {errors.newPassword}
          </div>
        )}


     
        <TextInput
          label="Confirmer le mot de passe"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          placeholder="Confirmez votre nouveau mot de passe"
          error={!!errors.confirmPassword}
          style={{ marginBottom: '8px' }}
            type='password'
        />
        {errors.confirmPassword && (
          <div style={{ color: '#d32f2f', fontSize: '12px', marginTop: '4px' }}>
            {errors.confirmPassword}
          </div>
        )}
 

      <div style={{ marginTop: '20px' }}>
        <Button
          label={isLoading ? "Réinitialisation..." : "Réinitialiser le mot de passe"}
          onClick={handleFormSubmit}
          disabled={isLoading}
          variant="primary"
          isLoading={isLoading}
          height="48px"
        />
      </div>

      <div style={{ 
        fontSize: '12px', 
        color: '#666', 
        textAlign: 'center',
        marginTop: '16px'
      }}>
        <div>Le mot de passe doit contenir :</div>
        <ul style={{ 
          textAlign: 'left', 
          margin: '8px 0', 
          paddingLeft: '20px' 
        }}>
          <li>Au moins 8 caractères</li>
          <li>Au moins une lettre majuscule</li>
          <li>Au moins une lettre minuscule</li>
          <li>Au moins un chiffre</li>
        </ul>
      </div>
    </div>
  )
}
